/**
 * BuildMate projesine özel renk paleti.
 * Az sayıda, düzenli seçim — scroll yok.
 */

export const TRANSPARENT_VALUE = 'transparent';

/** Küçük, düzenli palet: primary, nötrler, vurgu renkleri (tek ekranda, scroll yok) */
const PRIMARY = ['#3b82f6', '#2563eb', '#1d4ed8', '#60a5fa', '#93c5fd'];
const NEUTRALS = ['#ffffff', '#f1f5f9', '#e2e8f0', '#94a3b8', '#475569', '#1e293b', '#000000'];
const ACCENTS = ['#ef4444', '#22c55e', '#eab308', '#a855f7', '#ec4899'];

export const BUILDMATE_COLOR_PALETTE: string[] = [...PRIMARY, ...NEUTRALS, ...ACCENTS];
